module.exports = __webpack_public_path__ + "static/media/header-landing-pages-menu.204662fc.svg";